import {useNavigate} from "react-router-dom"
import { useTuckshopIDContext } from "../hooks/useTuckshopIDContext"

const MatuckshopDetails = ({tuckshop})=> {

 const {dispatch} = useTuckshopIDContext()
 const navigate = useNavigate()

 const handleClick = async() => {
   const jsons= JSON.stringify(tuckshop._id)
    dispatch({type:'set_id',payload:jsons})
        navigate("/viewtuckshop")
 }

        
    return(
   <div className="matuckshop-details">
    <h4>{tuckshop.tuckshopname}</h4>
    <p><strong>Location: </strong>{tuckshop.location}</p>
    <p><strong>Contact details:</strong>{tuckshop.contacts}</p>
    <p><strong>Description: </strong>{tuckshop.description}</p>
    <p>{tuckshop.createdAt}</p>
    <button type="button" onClick= {handleClick}> View Tuckshop </button>
   </div>
    )
}

export default MatuckshopDetails